/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ taxes: NonNullable<unknown> }} Admin_Shared_Incl_TaxInputs */

const en_admin_shared_incl_tax = /** @type {(inputs: Admin_Shared_Incl_TaxInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`incl. ${i?.taxes}`)
};

/** @type {(inputs: Admin_Shared_Incl_TaxInputs) => LocalizedString} */
const de_admin_shared_incl_tax = en_admin_shared_incl_tax;

/** @type {(inputs: Admin_Shared_Incl_TaxInputs) => LocalizedString} */
const es_admin_shared_incl_tax = en_admin_shared_incl_tax;

/** @type {(inputs: Admin_Shared_Incl_TaxInputs) => LocalizedString} */
const fr_admin_shared_incl_tax = en_admin_shared_incl_tax;

/** @type {(inputs: Admin_Shared_Incl_TaxInputs) => LocalizedString} */
const it_admin_shared_incl_tax = en_admin_shared_incl_tax;

/** @type {(inputs: Admin_Shared_Incl_TaxInputs) => LocalizedString} */
const pt_br2_admin_shared_incl_tax = en_admin_shared_incl_tax;

/** @type {(inputs: Admin_Shared_Incl_TaxInputs) => LocalizedString} */
const pl_admin_shared_incl_tax = en_admin_shared_incl_tax;

/** @type {(inputs: Admin_Shared_Incl_TaxInputs) => LocalizedString} */
const hu_admin_shared_incl_tax = en_admin_shared_incl_tax;

/** @type {(inputs: Admin_Shared_Incl_TaxInputs) => LocalizedString} */
const ro_admin_shared_incl_tax = en_admin_shared_incl_tax;

/**
* | output |
* | --- |
* | "incl. {taxes}" |
*
* @param {Admin_Shared_Incl_TaxInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_shared_incl_tax = /** @type {((inputs: Admin_Shared_Incl_TaxInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Shared_Incl_TaxInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_shared_incl_tax(inputs)
	if (locale === "de") return de_admin_shared_incl_tax(inputs)
	if (locale === "es") return es_admin_shared_incl_tax(inputs)
	if (locale === "fr") return fr_admin_shared_incl_tax(inputs)
	if (locale === "it") return it_admin_shared_incl_tax(inputs)
	if (locale === "pt-BR") return pt_br2_admin_shared_incl_tax(inputs)
	if (locale === "pl") return pl_admin_shared_incl_tax(inputs)
	if (locale === "hu") return hu_admin_shared_incl_tax(inputs)
	return ro_admin_shared_incl_tax(inputs)
});
export { admin_shared_incl_tax as "admin.shared.incl_tax" }